
<div class="popWrap01">
  <div class="pop_header">
    <h1> {{ "REG1100.LABEL.TRACK_YOUR_REQUEST_ONLINE_MERCHANT_STATUS" | translate }} </h1>
    <div class="close-modal1">
      <button type="button" tabindex="-1" class="btn_popclose" (click)="close()">
        <span class="k-icon k-i-close"></span>
      </button>
    </div>
  </div>

  <h3> {{ "REG1100.LABEL.PLEASE_FILL_IN_YOUR_PHONE_NUMBER_BELOW" | translate }} </h3>
  <div class="form nopadding">
    <div class="row_form">
      <div class="col">
        <dl>
          <dt> {{ "REG1100.LABEL.CONTACT_NUMBER" | translate }} </dt>
          <dd class="dflex">
            <div class="input_box w260">
                <input type="text"
                [placeholder]=" 'REG1100.LABEL.CONTACT_NUMBER' | translate "
                [(ngModel)]="searchPhoneNumberStatus"
                (keypress)="onlyNumbers($event);"
                (keyup)="formatPhoneNumber($event)"
                (paste)="onPaste($event)"
                autocomplete="off" 
                minlength="10"
                maxlength="12"
                >
                <button type="button" class="btn_text_del" *ngIf="searchPhoneNumberStatus" (click)="searchPhoneNumberStatus = '' "><span></span></button>
            </div>
            <button type="button" class="btn02 btn_text_r_ico02 search" (click)="getTrackStatusData()"><span>{{"REG1100.BUTTON.SEARCH" | translate}}</span></button>
          </dd>
        </dl>
      </div>
    </div>
  </div> 

  <div class="box_result">
    <span [ngClass]=" { 'loader': loading } "></span>
    <p class="txt_not_found" *ngIf="isPhoneNotFound"> {{ "REG1100.LABEL.PHONE_NUMBER_NOT_FOUND" | translate }}
      <br/> {{ "REG1100.LABEL.PLEASE_CHECK_YOUR_PHONE_NUMBER_AGAIN!" | translate }}
    </p>
    <div class="tracking_status" *ngIf="isPhoneNumber">
      <div class="form nopadding">
        <div class="row_form">
          <div class="col">
            <dl class="dflex">
              <dt> {{ "REG1100.LABEL.MERCHANT_NAME" | translate }} :</dt>
              <dd class="w260">
                <kendo-dropdownlist 
                [data]="statusData"
                [(ngModel)]="selectedMerchant"
                (valueChange)="onSelectMerchantList()"
                [textField]="'merchantName'"
                [valueField]="'key'"
                [value]="statusData[0]"
                >
                </kendo-dropdownlist>
              </dd>
            </dl>
          </div>
        </div>
        <div class="row_form">
          <div class="col">
            <dl class="dflex">
              <dt> {{ "REG1100.LABEL.REQUEST_DATE" | translate }} :</dt>
              <dd> {{ merchantRequestDate }} </dd>
            </dl>
          </div>
        </div>
      </div>

      <div class="result">
        <ul class="status">
          <li class="step02">
            <div [ngClass]=" { 'active': stepOne } ">
              <span> {{ "REG1100.LABEL.SUBMIT" | translate }} </span>
            </div>
          </li>
          <li class="step02" *ngIf="isNormalStatus">
            <div [ngClass]=" { 'active': stepTwo } ">
              <span> {{ "REG1100.LABEL.PROCESSING" | translate }} </span>
            </div>
          </li>
          <li class="step02" *ngIf="isNormalStatus">
            <div [ngClass]=" { 'active': stepThree } ">
              <span> {{ "REG1100.LABEL.COMPLETE" | translate }} </span>
            </div>
          </li>
          <li class="step02"  *ngIf="!isNormalStatus">
            <div [ngClass]=" { 'active': isRejectStatus } ">
              <span>Reject</span>
            </div>
          </li>
        </ul>
      </div>

      <div class="wrap_btn c_btn">
        <button *ngIf="isNormalStatus" type="button" class="btn01" [disabled]="isButtonActive" (click)="onClickDownloadQRImage()"><span>{{"REG1100.BUTTON.DOWNLOAD_QR_IMAGE" | translate}}</span></button>
      </div>
    </div>
  </div>
</div>